/**
 * Songs store their loudness normalisation as a 0-1 multiplier (`ALLKARAOKE_VOLUME` in the .txt,
 * and the convert screen's slider runs 0.1-1), but the players take 0-100 like the YouTube API
 * does. Mixing the two up plays a song at 1% - `setVolume(Math.round(0.68))` is 1, not 68 - so the
 * conversion lives here and nowhere else.
 */
export const DEFAULT_SONG_VOLUME = 0.7;

export const songVolumeToPlayerVolume = (volume: number | undefined) =>
  Math.round(Math.min(Math.max(volume ?? DEFAULT_SONG_VOLUME, 0), 1) * 100);
